import { Tooltip } from "@mui/material";
import React, { useState } from "react";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { Icon } from "@iconify/react";
import NotePad from "src/components/Notepad/NotePad";

function NotePadBox(props) {
  const [isExpandedChat, setIsExpandedChat] = useState(false);
  const [changeDis, setChangeDis] = useState(false);
  const { isOpenNotePad, handleCloseChat, selectedNotepad } = props;

  const bottom_in_chat = {
    hidden: {
      y: "100px",
      x: "0px",
      height: "0",
      opacity: 1,
      scale: 1,
    },
    visible: {
      opacity: 1,
      scale: 1,
      height: "67vh",
      y: "0px",
      x: "0px",
      transition: { delay: 0, duration: 0.5 },
    },
  };

  useEffect(() => {
    setIsExpandedChat(true);
  }, [isOpenNotePad, selectedNotepad]);

  return (
    <>
      <div
        className="user-chat-box-header d-flex align-items-center justify-content-between"
        onClick={() => setIsExpandedChat(!isExpandedChat)}
      >
        <div className="d-flex align-items-center">
          <div className="user-box-heading ms-2">
            Notes For {selectedNotepad?.title}{" "}
            {selectedNotepad?.member_id ? `(Member)` : ""}
          </div>
        </div>
        <div className="d-flex align-items-center">
          {isExpandedChat ? (
            <Icon icon="akar-icons:chevron-down" />
          ) : (
            <Icon icon="akar-icons:chevron-up" />
          )}
          <Tooltip
            title={changeDis ? "Please save your changes first" : ""}
            placement="top"
            arrow
          >
            <div>
              <Icon
                onClick={() => {
                  if (!changeDis) {
                    handleCloseChat();
                  }
                }}
                className="ms-2 chat-box-cross-icon"
                icon="charm:cross"
                style={{ cursor: "pointer" }}
              />
            </div>
          </Tooltip>
        </div>
      </div>
      <motion.div
        variants={bottom_in_chat}
        initial="hidden"
        animate={isExpandedChat ? "visible" : "hidden"}
        exit="hidden"
      >
        <NotePad
          data={selectedNotepad}
          setChangeDis={setChangeDis}
          changeDis={changeDis}
        />
      </motion.div>
    </>
  );
}

export default NotePadBox;
